import SearchChat from "./SearchChat";

export default SearchChat